var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTabDropDown = function SvgTabDropDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.5 3.6a.9.9 0 0 1 .9-.9h11.7a.9.9 0 0 1 0 1.8H5.4a.9.9 0 0 1-.9-.9m12.6 4.5H.9a.9.9 0 0 0 0 1.8h16.2a.9.9 0 0 0 0-1.8m0 5.4H9a.9.9 0 0 0 0 1.8h8.1a.9.9 0 0 0 0-1.8"
  })));
};
export { SvgTabDropDown as ReactComponent };
export default "/_next/static/media/static/media/tabDropDown.b3203d30e4d8200669878841954efa36svg";